<!-- Colocado este ngIf, porque estava a dar erros ao carregar dados. Os dados carregavam, mas a consola ficava cheia de erros.
     Assim, só são mesmo apresentados dados após o contract estar preenchido! -->
<div class="mv-detail" *ngIf="contract">
    <!-- #region Header -->
    <div class="mv-hero">
        <div class="mv-hero__main">
            <div class="mv-hero__icon">
                <i class="far fa-file-contract"></i>
            </div>

            <div class="mv-hero__heading">
                <div class="mv-hero__eyebrow">{{ 'CONTRACT_NUMBER' | translate }}</div>
                <h1 class="mv-hero__title">
                    <button type="button" class="mv-copy" *ngIf="contract.mvContractNumber; else noNumber" (click)="copyToClipBoard(contract.mvContractNumber)">
                        {{ contract.mvContractNumber }}
                        <i class="far fa-clone"></i>
                    </button>
                    <ng-template #noNumber>-</ng-template>

                    <span class="mv-status" [ngClass]="'mv-status--' + getStatusColor(contract.status)">
                        {{ 'CONTRACT_STATES.' + contract.status | translate }}
                    </span>
                </h1>
            </div>
        </div>

        <div class="mv-hero__fields">
            <dl class="mv-fields">
                <div class="mv-field">
                    <dt>{{ 'ENTITY_NAME' | translate }}</dt>
                    <dd>{{ contract.entity.name | empty: '-' }}</dd>
                </div>
                <div class="mv-field">
                    <dt>{{ 'SUPPLIER' | translate }}</dt>
                    <dd>{{ contract.supplierName | empty: '-' }}</dd>
                </div>
                <div class="mv-field">
                    <dt>{{ 'PRODUCT' | translate }}</dt>
                    <dd>{{ contract.supplierProduct.name | empty: '-' }}</dd>
                </div>
                <div class="mv-field">
                    <dt>{{ 'SALESMAN' | translate }}</dt>
                    <dd>{{ contract.salesman.name | empty: '-' }}</dd>
                </div>
                <div class="mv-field mv-field--wide">
                    <dt>{{ 'ASSOCIATED_BACKOFFICE' | translate }}</dt>
                    <dd>{{ contract.associatedBOMV | empty: '-' }}</dd>
                </div>
            </dl>
        </div>

        <nav class="mv-tabs" role="tablist" *ngIf="tabLayout$ | async as tabLayout">
            <button type="button" role="tab" class="mv-tabs__item" *ngFor="let tab of tabLayout.tabItems"
                    [class.active]="tabLayout.selectedMenu == tab.id" [attr.aria-selected]="tabLayout.selectedMenu == tab.id"
                    (click)="tabLayout.selectedMenu = tab.id; onTabChange(tab.id)">
                {{ tab.label }}
            </button>
        </nav>
    </div>
    <!-- #endregion Header -->

    <ng-container *ngIf="tabLayout$ | async as tabLayout">
        <!-- #region Client info -->
        <ng-container *ngIf="tabLayout.selectedMenu == 0">
            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-entity" aria-expanded="true" aria-controls="cardCollapse-entity">
                    <span class="mv-section__icon"><i class="far fa-building"></i></span>
                    <h2 class="mv-section__title">{{ 'ENTITY_DATA' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-entity" class="collapse show">
                    <div class="mv-section__body">
                        <dl class="mv-fields">
                            <div class="mv-field">
                                <dt>{{ 'TIN' | translate }}</dt>
                                <dd>{{ contract.entity.tin | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field" *ngIf="contract.entity.permanentCertificateCode">
                                <dt>{{ 'CRC' | translate }}</dt>
                                <dd>{{ contract.entity.permanentCertificateCode }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'CELLPHONE' | translate }}</dt>
                                <dd>{{ (contract.entity.cellPhoneNumber == '' ? contract.entity.phoneNumber : contract.entity.cellPhoneNumber) | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'EMAIL' | translate }}</dt>
                                <dd>{{ contract.entity.email | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'SOCIAL_RATE' | translate }}</dt>
                                <dd>{{ (contract.entity.isSocialRate ? 'YES' : 'NO') | translate }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'GDPR_STATEMENT' | translate }}</dt>
                                <dd>{{ (contract.entity.hasGDPRStatement ? 'YES' : 'NO') | translate }}</dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </section>

            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-legalReps" aria-expanded="true" aria-controls="cardCollapse-legalReps">
                    <span class="mv-section__icon"><i class="far fa-user-tie"></i></span>
                    <h2 class="mv-section__title">{{ 'LEGAL_REPRESENTATIVES' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-legalReps" class="collapse show">
                    <div class="mv-section__body">
                        <table mat-table class="mv-mat-table" [dataSource]="legalRepresentativesDataSource">
                            <ng-container matColumnDef="TIN">
                                <th mat-header-cell *matHeaderCellDef>{{ 'TIN' | translate }}</th>
                                <td mat-cell *matCellDef="let item">{{ item.tin }}</td>
                            </ng-container>

                            <ng-container matColumnDef="NAME">
                                <th mat-header-cell *matHeaderCellDef>{{ 'NAME' | translate }}</th>
                                <td mat-cell *matCellDef="let item">{{ item.name }}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                            <tr class="spinner-wrapper" *matNoDataRow>
                                <td *ngIf="_spinnerService.getInComponentSpinnerStatus('LegalRepresentatives'); else noLegalReps" [attr.colspan]="displayedColumns.length" class="text-center py-15">
                                    <ngx-spinner [zIndex]="1000" [fullScreen]="false" bdColor="rgba(128, 128, 128, 0.6)" [size]="'medium'" name="LegalRepresentatives" type="ball-spin-clockwise"></ngx-spinner>
                                </td>
                                <ng-template #noLegalReps>
                                    <td [attr.colspan]="displayedColumns.length" class="mv-empty mv-empty--compact">{{ 'NO_DATA_FOUND' | translate }}</td>
                                </ng-template>
                            </tr>
                        </table>
                    </div>
                </div>
            </section>

            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-contactPeople" aria-expanded="true" aria-controls="cardCollapse-contactPeople">
                    <span class="mv-section__icon"><i class="far fa-address-book"></i></span>
                    <h2 class="mv-section__title">{{ 'CONTACT_PEOPLE' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-contactPeople" class="collapse show">
                    <div class="mv-section__body">
                        <table mat-table class="mv-mat-table" [dataSource]="contactPeopleDataSource">
                            <ng-container matColumnDef="TIN">
                                <th mat-header-cell *matHeaderCellDef>{{ 'TIN' | translate }}</th>
                                <td mat-cell *matCellDef="let item">{{ item.personTIN }}</td>
                            </ng-container>

                            <ng-container matColumnDef="NAME">
                                <th mat-header-cell *matHeaderCellDef>{{ 'NAME' | translate }}</th>
                                <td mat-cell *matCellDef="let item">{{ item.personFirstName + ' ' + item.personLastName }}</td>
                            </ng-container>

                            <ng-container matColumnDef="ROLE">
                                <th mat-header-cell *matHeaderCellDef>{{ 'ROLE' | translate }}</th>
                                <td mat-cell *matCellDef="let item">{{ item.role }}</td>
                            </ng-container>

                            <ng-container matColumnDef="CONTACT_DATA_DESIGNATION">
                                <th mat-header-cell *matHeaderCellDef>{{ 'CONTACT_DATA_DESIGNATION' | translate }}</th>
                                <td mat-cell *matCellDef="let item">{{ item.contactDataDesignation }}</td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsContactPeople"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsContactPeople;"></tr>
                            <tr class="spinner-wrapper" *matNoDataRow>
                                <td *ngIf="_spinnerService.getInComponentSpinnerStatus('ContactPeople'); else noContactPeople" [attr.colspan]="displayedColumnsContactPeople.length" class="text-center py-15">
                                    <ngx-spinner [zIndex]="1000" [fullScreen]="false" bdColor="rgba(128, 128, 128, 0.6)" [size]="'medium'" name="ContactPeople" type="ball-spin-clockwise"></ngx-spinner>
                                </td>
                                <ng-template #noContactPeople>
                                    <td [attr.colspan]="displayedColumnsContactPeople.length" class="mv-empty mv-empty--compact">{{ 'NO_DATA_FOUND' | translate }}</td>
                                </ng-template>
                            </tr>
                        </table>
                    </div>
                </div>
            </section>
        </ng-container>
        <!-- #endregion -->

        <!-- #region Contract data -->
        <ng-container *ngIf="tabLayout.selectedMenu == 1">
            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-contractualInfo" aria-expanded="true" aria-controls="cardCollapse-contractualInfo">
                    <span class="mv-section__icon"><i class="far fa-file-lines"></i></span>
                    <h2 class="mv-section__title">{{ 'CONTRACTUAL_INFORMATION' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-contractualInfo" class="collapse show">
                    <div class="mv-section__body">
                        <dl class="mv-fields">
                            <div class="mv-field">
                                <dt>{{ 'GENERAL_CONDITION' | translate }}</dt>
                                <dd>{{ contract.productGeneralCondition.name | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'PARTICULAR_CONDITION' | translate }}</dt>
                                <dd>{{ contract.productParticularCondition.name | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'SIGNATURE_DATE' | translate }}</dt>
                                <dd>{{ (contract.signatureDate | date:'dd/MM/yyyy hh:mm:ss') | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'ELECTRONIC_INVOICE' | translate }}</dt>
                                <dd>{{ (contract.electronicInvoice ? 'YES' : 'NO') | translate }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'COMMUNICATIONS_ADDRESS' | translate }}</dt>
                                <dd>{{ contract.addressComunications | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'COUNTY' | translate }}</dt>
                                <dd>{{ contract.entity.address.county | empty: '-' }}</dd>
                            </div>
                            <div class="mv-field">
                                <dt>{{ 'DISTRICT' | translate }}</dt>
                                <dd>{{ contract.entity.address.district | empty: '-' }}</dd>
                            </div>
                        </dl>
                    </div>
                </div>
            </section>

            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-electricitySupply" aria-expanded="true" aria-controls="cardCollapse-electricitySupply">
                    <span class="mv-section__icon"><i class="far fa-bolt"></i></span>
                    <h2 class="mv-section__title">{{ 'ELECTRICITY_SUPPLY' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-electricitySupply" class="collapse show">
                    <div class="mv-section__body">
                        <is-table [DataSource$]="electricitySuppliesDataSource$!" [queryable]="true" [fullPageSpinner]="false" [showSpinner]="true"></is-table>
                    </div>
                </div>
            </section>

            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-gasSupply" aria-expanded="true" aria-controls="cardCollapse-gasSupply">
                    <span class="mv-section__icon"><i class="far fa-fire"></i></span>
                    <h2 class="mv-section__title">{{ 'NATURAL_GAS_SUPPLY' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-gasSupply" class="collapse show">
                    <div class="mv-section__body">
                        <is-table [DataSource$]="naturalGasSuppliesDataSource$!" [queryable]="true" [fullPageSpinner]="false" [showSpinner]="true"></is-table>
                    </div>
                </div>
            </section>

            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-selfConsumption" aria-expanded="true" aria-controls="cardCollapse-selfConsumption">
                    <span class="mv-section__icon"><i class="far fa-solar-panel"></i></span>
                    <h2 class="mv-section__title">{{ 'SELFCONSUMPTION' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-selfConsumption" class="collapse show">
                    <div class="mv-section__body">
                        <is-table [DataSource$]="selfConsumptionSuppliesDataSource$!" [queryable]="true" [fullPageSpinner]="false" [showSpinner]="true"></is-table>
                    </div>
                </div>
            </section>
        </ng-container>
        <!-- #endregion -->

        <!-- #region Other data -->
        <ng-container *ngIf="tabLayout.selectedMenu == 2">
            <section class="mv-section">
                <div class="mv-section__header">
                    <span class="mv-section__icon"><i class="far fa-credit-card"></i></span>
                    <h2 class="mv-section__title">{{ 'PAYMENT_WAYS' | translate }}</h2>
                </div>
                <div class="mv-section__body">
                    <dl class="mv-fields">
                        <div class="mv-field">
                            <dt>{{ 'PAYMENT_TYPE' | translate }}</dt>
                            <dd>{{ contract.paymentType | translate }}</dd>
                        </div>
                    </dl>
                </div>
            </section>

            <section class="mv-section">
                <div class="mv-section__header">
                    <span class="mv-section__icon"><i class="far fa-folder-open"></i></span>
                    <h2 class="mv-section__title">{{ 'FILES' | translate }}</h2>
                </div>
                <div class="mv-section__body">
                    <table mat-table #filesTable class="mv-mat-table" [dataSource]="filesDataSource">
                        <ng-container matColumnDef="FILE">
                            <th mat-header-cell *matHeaderCellDef>{{ 'FILE' | translate }}</th>
                            <td mat-cell *matCellDef="let file" class="fw-semibold">{{ file.name }}</td>
                        </ng-container>

                        <ng-container matColumnDef="TYPE">
                            <th mat-header-cell *matHeaderCellDef>{{ 'TYPE' | translate }}</th>
                            <td mat-cell *matCellDef="let file">{{ file.type }}</td>
                        </ng-container>

                        <ng-container matColumnDef="CREATED">
                            <th mat-header-cell *matHeaderCellDef>{{ 'CREATED' | translate }}</th>
                            <td mat-cell *matCellDef="let file">{{ file.uploadDate | date:'dd/MM/yyyy' }}</td>
                        </ng-container>

                        <ng-container matColumnDef="OPTIONS">
                            <th mat-header-cell *matHeaderCellDef>{{ 'OPTIONS' | translate }}</th>
                            <td mat-cell *matCellDef="let row">
                                <button type="button" class="mv-text-btn" (click)="viewFile(row)">
                                    <i class="far fa-eye me-1"></i>{{ 'SHOW' | translate }}
                                </button>
                                <button type="button" class="mv-text-btn" (click)="onDownloadFile(row)">
                                    <i class="far fa-download me-1"></i>{{ 'DOWNLOAD_DATA' | translate }}
                                </button>
                            </td>
                        </ng-container>

                        <tr mat-header-row *matHeaderRowDef="displayedColumnsFiles"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumnsFiles;"></tr>
                        <tr class="spinner-wrapper" *matNoDataRow>
                            <td *ngIf="_spinnerService.getInComponentSpinnerStatus('Files'); else noFiles" [attr.colspan]="displayedColumnsFiles.length" class="text-center py-15">
                                <ngx-spinner [zIndex]="1000" [fullScreen]="false" bdColor="rgba(128, 128, 128, 0.6)" [size]="'medium'" name="Files" type="ball-spin-clockwise"></ngx-spinner>
                            </td>
                            <ng-template #noFiles>
                                <td [attr.colspan]="displayedColumnsFiles.length" class="mv-empty mv-empty--compact">{{ 'NO_DATA_FOUND' | translate }}</td>
                            </ng-template>
                        </tr>
                    </table>
                </div>
            </section>
        </ng-container>
        <!-- #endregion -->

        <!-- #region History -->
        <ng-container *ngIf="tabLayout.selectedMenu == 3">
            <section class="mv-section">
                <button type="button" class="mv-section__header" data-bs-toggle="collapse" data-bs-target="#cardCollapse-history" aria-expanded="true" aria-controls="cardCollapse-history">
                    <span class="mv-section__icon"><i class="far fa-clock-rotate-left"></i></span>
                    <h2 class="mv-section__title">{{ 'HISTORY' | translate }}</h2>
                    <i class="far fa-chevron-down mv-section__chevron"></i>
                </button>
                <div id="cardCollapse-history" class="collapse show">
                    <div class="mv-section__body">
                        <table mat-table #historyTable class="mv-mat-table" [dataSource]="historyDataSource">
                            <ng-container matColumnDef="TYPE">
                                <th mat-header-cell *matHeaderCellDef>{{ 'TYPE' | translate }}</th>
                                <td mat-cell *matCellDef="let row">{{ row.type.toUpperCase() | translate }}</td>
                            </ng-container>

                            <ng-container matColumnDef="MODIFICATION_DATE">
                                <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_DATE' | translate }}</th>
                                <td mat-cell *matCellDef="let row">{{ row.modificationDate | date:'dd/MM/yyyy - HH:mm' }}</td>
                            </ng-container>

                            <ng-container matColumnDef="MODIFICATION_BY">
                                <th mat-header-cell *matHeaderCellDef>{{ 'MODIFICATION_BY' | translate }}</th>
                                <td mat-cell *matCellDef="let row">{{ row.modifiedBy }}</td>
                            </ng-container>

                            <ng-container matColumnDef="ACTIONS">
                                <th mat-header-cell *matHeaderCellDef></th>
                                <td mat-cell *matCellDef="let item" class="text-end">
                                    <button type="button" class="mv-text-btn" (click)="historyClick(item.guidId)">
                                        {{ 'VIEW_HISTORY' | translate }}<i class="far fa-arrow-right ms-1"></i>
                                    </button>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="displayedColumnsHistory"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumnsHistory;"></tr>
                            <tr class="spinner-wrapper" *matNoDataRow>
                                <td *ngIf="_spinnerService.getInComponentSpinnerStatus('History'); else noHistory" [attr.colspan]="displayedColumnsHistory.length" class="text-center py-15">
                                    <ngx-spinner [zIndex]="1000" [fullScreen]="false" bdColor="rgba(128, 128, 128, 0.6)" [size]="'medium'" name="History" type="ball-spin-clockwise"></ngx-spinner>
                                </td>
                                <ng-template #noHistory>
                                    <td [attr.colspan]="displayedColumnsHistory.length" class="mv-empty mv-empty--compact">{{ 'NO_DATA_FOUND' | translate }}</td>
                                </ng-template>
                            </tr>
                        </table>
                    </div>
                </div>
            </section>
        </ng-container>
        <!-- #endregion -->
    </ng-container>
</div>
